import styled, { keyframes, css } from "styled-components";
import tinycolorr from "tinycolor2";

// Definição das animações
const slideAnimation = (minWidth) => keyframes`
10% {
  min-width: ${minWidth}px;
}
80% {
  min-width: ${minWidth}px;
}
100% {
  min-width: 0;
}
`;

export const SliderContainer = styled.div`
  pointer-events: auto;
  cursor: pointer;
  background-color: ${(props) => tinycolorr(props.backgroundColor)};
  overflow: hidden;
  position: relative;
  min-width: 0;
  transition: all 1s;
  margin-right: ${(props) => props.marginRight}px;
  margin-left: ${(props) => props.marginLeft}px;
  margin-bottom: ${(props) => props.marginBottom}px;
  line-height: ${(props) => props.buttonHeight + "px"};
  letter-spacing: 0.4px;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  color: white;
  ${(props) =>
    props.animation &&
    css`
      animation-name: ${slideAnimation(props.slideSpanTextWidth)};
      animation-duration: 4s;
      animation-timing-function: linear;
      animation-iteration-count: 1;
      animation-delay: ${props.animationDelay}s;
    `}
  ${(props) => props.shapeStyles}
  &:hover {
    min-width: ${(props) => props.slideSpanTextWidth}px;
  }
`;